<template>
  <div>
    <v-img
      v-if="logoexists"
      class="mx-auto d-print-none mb-2"
      contain
      height="40"
      max-width="60"
      :src="'/images/TeamLogo/SVG/' + logo + '.svg'"
    />
    <h4>
      {{ name }}
      <br />
      <v-tooltip top v-if="showScheduleLink && !$route.params.team">
        <template v-slot:activator="{ on }">
          <v-btn
            x-small
            icon
            class="d-print-none"
            color="primary"
            v-on="on"
            :href="'/s/' + leagueSlug + '/' + teamSlug"
          >
            <v-icon x-small> mdi-calendar </v-icon>
          </v-btn>
        </template>
        <span>Monthly Schedule</span>
      </v-tooltip>
    </h4>
  </div>
</template>

<script>
export default {
  name: "Bundle",
  props: {
    logoexists: Boolean,
    logo: Number,
    name: String,
    leagueSlug: String,
    teamSlug: String,
    showScheduleLink: Boolean
  },
};
</script>